import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Layout from '@organisms/layout'

const Links = {
  twitter: 'https://twitter.com/klipfolio',
  facebook: 'https://www.facebook.com/Klipfolio',
  linkedin: 'https://www.linkedin.com/company/klipfolio',
  instagram: 'https://www.instagram.com/klipfolio/',
  youtube: 'https://www.youtube.com/klipfolio'
}

const SocialComponent = ({ children, className, href = '/', ariaLabel }) => {
  return (
    <a href={href} target="_blank" rel="noreferrer" aria-label={ariaLabel} className={className}>
      {children}
    </a>
  )
}

SocialComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  href: PropTypes.string,
  ariaLabel: PropTypes.string
}

const Social = styled(SocialComponent)`
  display: flex;
  height: ${props => (props.height + props.margin + 4) || 48}px;
  width: ${props => (props.width + props.margin + 4) || 35}px;
  align-items: center;
  svg {
    width: ${props => props.width || 30}px;
    height: ${props => props.height || 30}px;
    margin: ${props => props.margin || 2}px;
    border-radius: 50%;
  }
`

const socialPropTypes = {
  href: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  margin: PropTypes.number,
}

const SocialTwitter = ({ href, width, height, margin }) => {
  return (
    <Social width={width} height={height} margin={margin} href={href || Links.twitter} ariaLabel={"Twitter"}>
      <svg
        id="twitter"
        version="1.1"
        viewBox="0 0 40 40"
        x="0px"
        xmlns="http://www.w3.org/2000/svg"
        y="0px"
      >
        <path
          d="M35,40H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v30C40,37.8,37.8,40,35,40z"
          style={{ fill: '#50ABF1' }}
        />
        <g>
          <path
            d="M30.5,13.5c-0.8,0.3-1.6,0.6-2.5,0.7c0.9-0.5,1.6-1.4,1.9-2.4c-0.8,0.5-1.8,0.9-2.7,1
                  c-0.8-0.8-1.9-1.4-3.1-1.4c-2.4,0-4.3,1.9-4.3,4.3c0,0.3,0,0.7,0.1,1c-3.6-0.2-6.8-1.9-8.9-4.5c-0.4,0.6-0.6,1.4-0.6,2.2
                  c0,1.5,0.8,2.8,1.9,3.6c-0.7,0-1.4-0.2-2-0.5c0,0,0,0,0,0.1c0,2.1,1.5,3.8,3.5,4.2c-0.4,0.1-0.7,0.2-1.1,0.2c-0.3,0-0.5,0-0.8-0.1
                  c0.5,1.7,2.1,3,4,3c-1.5,1.2-3.3,1.8-5.4,1.8c-0.3,0-0.7,0-1-0.1c1.9,1.2,4.2,1.9,6.6,1.9c7.9,0,12.3-6.6,12.3-12.3
                  c0-0.2,0-0.4,0-0.6C29.2,15.1,29.9,14.4,30.5,13.5z"
            style={{ fill: '#FFFFFF' }}
          />
        </g>
      </svg>
    </Social>
  )
}

SocialTwitter.propTypes = socialPropTypes

const SocialFacebook = ({ href, width, height, margin }) => {
  return (
    <Social width={width} height={height} margin={margin} href={href || Links.facebook} ariaLabel={"Facebook"}>
      <svg
        id="facebook"
        version="1.1"
        viewBox="0 0 40 40"
        x="0px"
        xmlns="http://www.w3.org/2000/svg"
        y="0px"
      >
        <path
          d="M35,40H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v30C40,37.8,37.8,40,35,40z"
          style={{ fill: '#395597' }}
        />
        <g>
          <g>
            <path
              d="M21.6,30.6v-9.7h3.2l0.5-3.8h-3.7v-2.4c0-1.1,0.3-1.8,1.9-1.8l2,0V9.6c-0.3,0-1.5-0.1-2.9-0.1
                          c-2.9,0-4.8,1.8-4.8,5v2.8h-3.3v3.8h3.3v9.7H21.6z"
              id="f"
              style={{ fill: '#FFFFFF' }}
            />
          </g>
        </g>
      </svg>
    </Social>
  )
}

SocialFacebook.propTypes = socialPropTypes

const SocialLinkedIn = ({ href, width, height, margin  }) => {
  return (
    <Social width={width} height={height} margin={margin} href={href || Links.linkedin} ariaLabel={"LinkedIn"}>
      <svg
        id="linkedin"
        version="1.1"
        viewBox="0 0 40 40"
        x="0px"
        xmlns="http://www.w3.org/2000/svg"
        y="0px"
      >
        <path
          d="M35,40H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v30C40,37.8,37.8,40,35,40z"
          style={{ fill: '#007BB5' }}
        />
        <g>
          <g>
            <path
              d="M11.3,17H15v12h-3.7V17z M13.2,11c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2
                          C11,12,12,11,13.2,11"
              style={{ fill: '#FFFFFF' }}
            />
            <path
              d="M17.4,17h3.6v1.6H21c0.5-0.9,1.7-1.9,3.5-1.9c3.8,0,4.5,2.5,4.5,5.7V29h-3.7v-5.8c0-1.4,0-3.2-1.9-3.2
                          c-1.9,0-2.2,1.5-2.2,3.1V29h-3.7V17z"
              style={{ fill: '#FFFFFF' }}
            />
          </g>
        </g>
      </svg>
    </Social>
  )
}

SocialLinkedIn.propTypes = socialPropTypes

const SocialInstagram = ({ href, width, height, margin }) => {
  return (
    <Social width={width} height={height} margin={margin} href={href || Links.instagram} ariaLabel={"Instagram"}>
      <svg
        id="instagram"
        version="1.1"
        viewBox="-619 341 40 40"
        x="0px"
        xmlns="http://www.w3.org/2000/svg"
        y="0px"
      >
        <path
          d="M-584,381h-30c-2.8,0-5-2.2-5-5v-30c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v30C-579,378.8-581.2,381-584,381z"
          style={{ fill: '#D73676' }}
        />
        <g>
          <path
            d="M-599,351.6c3.1,0,3.4,0,4.6,0.1c1.1,0.1,1.7,0.2,2.1,0.4c0.5,0.2,0.9,0.5,1.3,0.9c0.4,0.4,0.7,0.8,0.9,1.3
                  c0.2,0.4,0.3,1,0.4,2.1c0.1,1.2,0.1,1.6,0.1,4.6s0,3.4-0.1,4.6c-0.1,1.1-0.2,1.7-0.4,2.1c-0.2,0.5-0.5,0.9-0.9,1.3
                  c-0.4,0.4-0.8,0.7-1.3,0.9c-0.4,0.2-1,0.3-2.1,0.4c-1.2,0.1-1.6,0.1-4.6,0.1s-3.4,0-4.6-0.1c-1.1-0.1-1.7-0.2-2.1-0.4
                  c-0.5-0.2-0.9-0.5-1.3-0.9s-0.7-0.8-0.9-1.3c-0.2-0.4-0.3-1-0.4-2.1c-0.1-1.2-0.1-1.6-0.1-4.6s0-3.4,0.1-4.6
                  c0.1-1.1,0.2-1.7,0.4-2.1c0.2-0.5,0.5-0.9,0.9-1.3c0.4-0.4,0.8-0.7,1.3-0.9c0.4-0.2,1-0.3,2.1-0.4
                  C-602.4,351.6-602.1,351.6-599,351.6 M-599,349.5c-3.1,0-3.5,0-4.7,0.1c-1.2,0.1-2.1,0.3-2.8,0.5c-0.8,0.3-1.4,0.7-2,1.3
                  c-0.6,0.6-1,1.3-1.3,2c-0.3,0.7-0.5,1.6-0.5,2.8c-0.1,1.2-0.1,1.6-0.1,4.7s0,3.5,0.1,4.7c0.1,1.2,0.3,2.1,0.5,2.8
                  c0.3,0.8,0.7,1.4,1.3,2c0.6,0.6,1.3,1,2,1.3c0.7,0.3,1.6,0.5,2.8,0.5c1.2,0.1,1.6,0.1,4.7,0.1s3.5,0,4.7-0.1
                  c1.2-0.1,2.1-0.3,2.8-0.5c0.8-0.3,1.4-0.7,2-1.3c0.6-0.6,1-1.3,1.3-2c0.3-0.7,0.5-1.6,0.5-2.8c0.1-1.2,0.1-1.6,0.1-4.7
                  s0-3.5-0.1-4.7c-0.1-1.2-0.3-2.1-0.5-2.8c-0.3-0.8-0.7-1.4-1.3-2c-0.6-0.6-1.3-1-2-1.3c-0.7-0.3-1.6-0.5-2.8-0.5
                  C-595.5,349.5-595.9,349.5-599,349.5L-599,349.5z"
            style={{ fill: '#FFFFFF' }}
          />
          <path
            d="M-599,355.1c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9s5.9-2.6,5.9-5.9S-595.7,355.1-599,355.1z M-599,364.8
                  c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8S-596.9,364.8-599,364.8z"
            style={{ fill: '#FFFFFF' }}
          />
          <circle cx="-592.9" cy="354.9" r="1.4" style={{ fill: '#FFFFFF' }} />
        </g>
      </svg>
    </Social>
  )
}

SocialInstagram.propTypes = socialPropTypes

const SocialYoutube = ({ href, width, height, margin }) => {
  return (
    <Social width={width} height={height} margin={margin} href={href || Links.youtube} ariaLabel={"Youtube"}>
      <svg
        version="1.1"
        viewBox="-619 341 40 40"
        x="0px"
        xmlns="http://www.w3.org/2000/svg"
        y="0px"
      >
        <g>
          <path
            d="M-584,381h-30c-2.8,0-5-2.2-5-5v-30c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v30C-579,378.8-581.2,381-584,381z"
            style={{ fill: '#E52D27' }}
          />
        </g>
        <g>
          <g>
            <g>
              <path
                d="M-586.7,356c0,0-0.2-1.7-1-2.5c-1-1-2-1-2.5-1.1c-3.5-0.3-8.7-0.3-8.7-0.3l0,0c0,0-5.2,0-8.7,0.3
                          c-0.5,0.1-1.6,0.1-2.5,1.1c-0.7,0.8-1,2.5-1,2.5s-0.2,2-0.2,4v1.9c0,2,0.2,4,0.2,4s0.2,1.7,1,2.5c1,1,2.2,1,2.8,1.1
                          c2,0.2,8.5,0.3,8.5,0.3s5.3,0,8.8-0.3c0.5-0.1,1.6-0.1,2.5-1.1c0.7-0.8,1-2.5,1-2.5s0.2-2,0.2-4V360
                          C-586.5,358-586.7,356-586.7,356z M-601.6,364.2v-7l6.8,3.5L-601.6,364.2z"
                style={{ fill: '#FFFFFF' }}
              />
            </g>
          </g>
          <path
            d="M-601.6,364.2l6.8-3.5l-6.8-3.5V364.2z"
            style={{ fill: '#E52D27' }}
          />
          <path
            d="M-601.6,357.2l5.9,4l0.8-0.4L-601.6,357.2z"
            style={{ opacity: 0.12, fill: '#3C3C3C', enableBackground: 'new' }}
          />
        </g>
      </svg>
    </Social>
  )
}

SocialYoutube.propTypes = socialPropTypes

const SocialRow = () => {
  return (
    <Layout.Row justify="flex-start" left={0} center>
      <SocialTwitter />
      <SocialFacebook />
      <SocialLinkedIn />
      <SocialInstagram />
      <SocialYoutube />
    </Layout.Row>
  )
}

Social.Row = SocialRow
Social.Youtube = SocialYoutube
Social.Instagram = SocialInstagram
Social.LinkedIn = SocialLinkedIn
Social.Facebook = SocialFacebook
Social.Twitter = SocialTwitter
export default Social
